import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { radiusSynced } from '../features/facetsSlice';

export const useRadiusSync = (isReady) => {
	const dispatch = useDispatch();
	const radius = useSelector((state) => state.facets.radius);
	const radiusRef = useRef(radius);

	useEffect(() => {
		radiusRef.current = radius;
	}, [radius]);

	useEffect(() => {
		const locationsData = window.DDC?.LocationsData;

		if (!locationsData?.registerRadiusChangedNotification) return () => {};

		if (locationsData.getRange) {
			const liveRadius = locationsData.getRange();
			if (
				typeof liveRadius === 'number' &&
				liveRadius !== radiusRef.current
			) {
				dispatch(radiusSynced(liveRadius));
			}
		}

		const unsubscribe = locationsData.registerRadiusChangedNotification(
			(data) => {
				const newRadius = data?.radius;
				if (
					typeof newRadius === 'number' &&
					newRadius !== radiusRef.current
				) {
					dispatch(radiusSynced(newRadius));
				}
			}
		);

		return unsubscribe;
	}, [dispatch, isReady]);
};
